import { createRouter, createWebHistory } from 'vue-router'
import { routes } from 'vue-router/auto-routes'
import { useSessionsStore } from '@/stores/sessions'
import { usePlayerStore } from '@/stores/player'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
})


const adminRoutes = [
    "/admin/*",
    "/session/[pinCode]/present",
    "/session/[pinCode]/treasure",
    "/session/[pinCode]/statistics/*",
]

export const isProtected = (route: string) => adminRoutes.some((path) => {
        if (route === "/admin" || route === "/admin/") return false

        const wildcardPath = path.split("*")[0]
        return path === route || route.startsWith(wildcardPath)
    })

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()
    const sessionsStore = useSessionsStore()


    if (isProtected(to.name.toString())) {
        if(!authStore.authChecked){
            await authStore.getMe()
        }
        if (!authStore.isAuthenticated) {
            // If not authenticated, redirect to admin login
            return next('/admin')
        }
    }

    // Secure session routes
    if (to.path.startsWith('/session/') && to.params.pinCode) {
        const session = await sessionsStore.setCurrentSessionByPin(to.params.pinCode as string)
        if (!session) {
            return next('/404')
        }

        // Player registration redirect logic
        const playerStore = usePlayerStore()

        // If going to /register and already registered for this session, redirect to /play
        if (
            to.name === '/session/[pinCode]/register' &&
            playerStore.player.name &&
            playerStore.player.sessionId === session!.id
        ) {
            return next(`/session/${to.params.pinCode}/`)
        }


        // Player pages require registration — admin routes and /register are excluded
        const isSessionRoute = to.name.toString().startsWith('/session/[pinCode]')
        const isPlayerPage = isSessionRoute && !isProtected(to.name.toString()) && to.name !== '/session/[pinCode]/register'
        const isRegistered = playerStore.player.name && playerStore.player.sessionId === session!.id

        if (isPlayerPage && !isRegistered) {
            return next(`/session/${to.params.pinCode}/register`)
        }


    }
    next()
})

export default router
